import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { GbrFile } from '@coin/shared/gbr/util';
import { RequestHandlerService } from '@coin/shared/core/data-access';
import { environment } from '@coin/shared/core/util-environments';
import { DownloadFileHelper } from '@coin/shared/core/util-helpers';
import { Observable } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';

@Injectable()
export class GbrDocumentsService {
  private http = inject(HttpClient);
  private requestHandler = inject(RequestHandlerService);

  public uploadGbrDocument(file: GbrFile, seasonId: string): Observable<object> {
    const params = new HttpParams().append('key', file.filePath);
    return this.http
      .get<{ signedUrl: string }>(`${environment.api.documentsUrl}/gbr/upload?seasonId=${seasonId}`, { params })
      .pipe(
        switchMap(({ signedUrl }) => this.http.put(signedUrl, file.file)),
        this.requestHandler.handleError(`Error while saving the file: ${file.fileName}`, true)
      );
  }

  public downloadGbrDocument(path: string): Observable<string> {
    return this.http
      .post(`${environment.api.documentsUrl}/gbr/download?signedUrl=true`, { key: path }, { responseType: 'text' })
      .pipe(tap(data => DownloadFileHelper.download(data, path.split('/').pop())));
  }
}
